import React from 'react';
import { Helmet } from 'react-helmet';

import favicon from '@/images/favicon.ico';
import preview from '@/images/preview.jpg';

interface IMeta {
  title: string;
  description?: string;
  keywords?: string;
  robots?: 'noindex' | 'nofollow' | 'index';
  author?: string;
  refresh?: boolean;
  image?: any;
  url?: string;
  structuredData?: string;
}

export const Meta: React.FC<IMeta> = ({
  title,
  description,
  keywords,
  robots,
  author,
  refresh,
  image,
  url = '',
  structuredData,
}) => (
  <Helmet>
    <title>{title}</title>
    <link rel="icon" href={favicon} />
    <meta charSet="UTF-8" />
    <meta name="viewport" content="initial-scale=1, viewport-fit=cover" />
    <meta name="image" content={image || preview} />
    {/* SEO */}
    {description && <meta name="description" content={description} />}
    {keywords && <meta name="keywords" content={keywords} />}
    {robots && <meta name="robots" content={robots} />}
    {/* Technical */}
    {author && <meta name="Author" content={author} />}
    {author && <meta name="Copyright" content={author} />}
    {refresh && <meta httpEquiv="refresh" content="1; url=index.html" />}
    {/* For Socials */}
    <meta property="og:locale" content="en_US" />
    <meta property="og:type" content={author ? 'article' : 'website'} />
    <meta property="og:title" content={title} />
    {description && <meta property="og:description" content={description} />}
    <meta property="og:image" content={image || preview} />
    <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content={author ? '1200' : '628'} />
    <meta property="og:url" content={`https://codeplatform.com${url}`} />
    <meta property="og:site_name" content="CodePlatform" />
    {/* Twitter */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={title} />
    {description && <meta name="twitter:description" content={description} />}
    <meta name="twitter:image" content={image || preview} />
    {structuredData && (
      <script type="application/ld+json">{structuredData}</script>
    )}
  </Helmet>
);
